<template>
  <BreadCrumb />
  <PageContainer class="carts-pc">
    <div class="carts-pc__content">
      <!-- 买家保障图片 -->
      <div class="carts-pc-banner">
        <img
          class="carts-pc-banner__logo"
          src="@/assets/carts/buyer-protection.svg"
          alt=""
        >
        Official Platform, Guaranteed Security
        <span>·</span>
        <div class="carts-pc-banner__hint">
          <Icon
            class="carts-pc-banner__icon"
            name="secure-payment-f"
          />
          <span>Secure Payments</span>
        </div>
        <span>·</span>
        <div class="carts-pc-banner__hint">
          <Icon
            class="carts-pc-banner__icon"
            name="secure-transfer-f"
          />
          <span class="carts-pc-banner__hint">Standard Refund Policy</span>
        </div>
        <span>·</span>
        <div class="carts-pc-banner__hint">
          <Icon
            class="carts-pc-banner__icon"
            name="lock-f"
          />
          <span class="carts-pc-banner__hint">Privacy Protection</span>
        </div>
      </div>

      <!-- 空列表 -->
      <EmptyList v-if="isAllEmpty" />

      <template v-else>
        <!-- 支付方式 -->
        <PaymentMethods />

        <!-- 头部和地址 -->
        <HeaderAddressBar />

        <!-- 状态菜单 -->
        <OrderStatusPanel />

        <!-- 列表 -->
        <CartList />
      </template>
    </div>
    <div class="carts-pc__sidebar">
      <Checkout />
    </div>
  </PageContainer>
</template>

<script setup>
import { watchOnce } from '@vueuse/core'
import BreadCrumb from './components/Breadcrumb.vue'
import PaymentMethods from './components/PaymentMethods.vue'
import HeaderAddressBar from './components/HeaderAddressBar.vue'
import OrderStatusPanel from './components/OrderStatusPanel.vue'
import CartList from './components/CartList/index.vue'
import Checkout from './components/Checkout/index.vue'
import EmptyList from './components/EmptyList.vue'
import { useAddressStore } from '@/pinia/address'
import { useCart } from '../hooks/useCart'
import { buriedPointUtil, gaAnalytics } from '@/utils/utils'
import { PageContainer } from '@/components/PageLayout'
import { Icon } from '@/components/Icon'

const addressStore = useAddressStore()

const { cartList, isAllEmpty } = useCart()

const checkAddress = () => {
  if (!addressStore.cacheAddress) {
    addressStore.show(3)
  }
}

onMounted(() => {
  buriedPointUtil({ eventId: 'PC501' })
  gaAnalytics('p_cart_page_view', 'p_cart_page_view')

  checkAddress()
})

watchOnce(cartList, (list) => {
  if (list.length) {
    buriedPointUtil({ eventId: 'PCL401' })
  }
})
</script>

<style lang='less' scoped>
.carts-pc {
  flex: 1;
  display: flex;

  :deep(.page-container__content) {
    flex: 1;
    display: flex;
    gap: 24px;
  }

  &__content {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  &-banner {
    margin-top: 24px;
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 6px 16px;
    background-color: #DFE8FB;
    border-radius: 4px;
    font-family: mon-700;
    font-size: 12px;
    line-height: 16px;
    color: #232323;

    &__logo {
      margin-right: 2px;
      width: 28px;
      height: 28px;
    }

    &__icon {
      font-size: 16px;
    }

    &__hint {
      display: flex;
      align-items: center;
      gap: 4px;
      color: #052784;
    }
  }

  &__sidebar {
    flex-shrink: 0;
    width: 24%;
    min-width: 288px;
    max-width: 432PX;
  }
}
</style>
